export default __webpack_public_path__ + "static/media/edit-rectangle.29b7df63.svg";